import { Box, Typography } from '@mui/material';
import * as React from 'react';

interface SearchHeaderProps {
  title?: string;
}

export const SearchHeader: React.FC<SearchHeaderProps> = ({
  title = 'HISTÓRICO DE EVENTOS',
}) => {
  return (
    <Box
      sx={{
        background:
          'linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important',
        borderRadius: '8px !important',
        p: 1,
        mb: 5,
        mt: 2,
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 50%, rgba(255,255,255,0.05) 100%)',
          pointerEvents: 'none',
        },
      }}
    >
      <Typography
        sx={{
          color: '#ffffff !important',
          fontSize: { xs: '11pt', md: '12pt' },
          fontFamily: 'Roboto-Bold !important',
          letterSpacing: '0.8px !important',
          textTransform: 'uppercase !important',
          position: 'relative',
          zIndex: 1,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};
